export type ActivateSuccessResponse = {
  success: boolean;
  message?: string;
};

export type VerifyActivationOtpResult = {
  token: string;
};

export type SetActivationPasswordResult = {
  success: boolean;
  user?: unknown;
};

export async function resendActivationOtp(input: { email?: string; phone?: string }): Promise<ActivateSuccessResponse> {
  const response = await fetch("/api/auth/user/resend-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "Failed to send activation code");
  }

  return json;
}

export async function verifyActivationOtp(input: { email?: string; phone?: string; otp: string }): Promise<VerifyActivationOtpResult> {
  const response = await fetch("/api/auth/user/verify-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "OTP verification failed");
  }

  return json.data; // contains token
}

export async function setActivationPassword(input: { email?: string; phone?: string; password?: string; token: string }): Promise<SetActivationPasswordResult> {
  const response = await fetch("/api/auth/user/set-password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "Failed to set password");
  }

  return json;
}
